"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeatNumber = exports.className = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../../../utils/classFunctions");
const FlightSeatCount_1 = require("../../../FlightSeatCount");
require("./index.scss");
exports.className = 'flight-list-info-seat-number';
const SeatNumber = (props) => {
    const { type, seatNumber } = props;
    const classNameWithType = (0, classFunctions_1.getClassNames)(exports.className, type);
    return (react_1.default.createElement("div", { className: classNameWithType },
        react_1.default.createElement(FlightSeatCount_1.FlightSeatCount, { value: seatNumber, allowedNegative: true })));
};
exports.SeatNumber = SeatNumber;
//# sourceMappingURL=index.js.map